import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoreFilterService {
  private _filter = new BehaviorSubject<any>(null);
  public filter$ = this._filter.asObservable();

  setFilter(value: any) {
    this._filter.next(value);
  }

  constructor() { }
}
